import { api } from '..';

interface Token {
  token: string;
}

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<Token, { token: string }>({
      query: (credentials) => ({
        url: 'auth/google',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (rawResult: { data: Token }) => {
        return rawResult.data;
      },
    }),
  }),
});
